import { useListCategories } from '@/apis/categories.api';

export const useCategories = () => {
  const { data, isLoading, error } = useListCategories();

  return {
    categories: data || [],
    isLoading,
    error,
  };
};
